import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchCashDiscounts, ProgramActionKeys, programsActionCreators } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';
import { IProgramCashDiscount } from '../programsInterfaces';

function* fetchCashDiscountsSaga(action: FetchCashDiscounts) {
  yield put(uiActionCreators.toggleLoading('programCashDiscounts'));
  const response: IApiExecuteRespone<IProgramCashDiscount[]> = yield call(
    api.fetchCashDiscounts,
    action.payload.fiscalYear
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setCashDiscounts(response.value));
  }

  yield put(uiActionCreators.toggleLoading('programCashDiscounts'));
}

export function* watchFetchCashDiscounts() {
  yield takeEvery(ProgramActionKeys.FETCH_CASH_DISCOUNTS, fetchCashDiscountsSaga);
}
